import { render, staticRenderFns } from "./filter-buttons.vue?vue&type=template&id=c9c9d820&scoped=true&"
import script from "./filter-buttons.vue?vue&type=script&lang=js&"
export * from "./filter-buttons.vue?vue&type=script&lang=js&"
import style0 from "./filter-buttons.vue?vue&type=style&index=0&id=c9c9d820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c9d820",
  null
  
)

export default component.exports